import { gql } from "@apollo/client";

export const CREATE_APP_VERSION = gql`
  mutation CreateAppVersion(
    $type: String!
    $versionCode: Int!
    $versionName: String!
    $url: String!
    $isForceUpdate: Boolean!
    $forceUpdateVersionCode: Int
    $enabledAt: String
    $description: String
  ) {
    createAppVersion(
      type: $type
      versionCode: $versionCode
      versionName: $versionName
      url: $url
      isForceUpdate: $isForceUpdate
      forceUpdateVersionCode: $forceUpdateVersionCode
      enabledAt: $enabledAt
      description: $description
    ) {
      id
      versionCode
      versionName
      url
      isForceUpdate
      forceUpdateVersionCode
      enabledAt
      description
      type
    }
  }
`;
